import "./index.css";

import App from "./App";
import { AuthContextProvider } from "./contexts/AuthCtx";
import PostHogProvider from "./analytics/PostHogProvider";
import { BrowserRouter } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";

const root = ReactDOM.createRoot(document.getElementById("root"));

TagManager.initialize({
  gtmId: process.env.REACT_APP_GTM_ID,
});

root.render(
  <AuthContextProvider>
    <BrowserRouter>
      <PostHogProvider>
        <App />
      </PostHogProvider>
    </BrowserRouter>
  </AuthContextProvider>
);
